import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, FormControl, InputLabel, Select, MenuItem, Box, } from '@mui/material';
const JobModal = ({ open, job, machineId, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        name: '',
        jobNumber: '',
        description: '',
        clientName: '',
        location: '',
        startDate: undefined,
        endDate: undefined,
        status: 'Planned',
    });
    useEffect(() => {
        if (open) {
            if (job) {
                setFormData({
                    name: job.name || '',
                    jobNumber: job.jobNumber || '',
                    description: job.description || '',
                    clientName: job.clientName || '',
                    location: job.location || '',
                    startDate: job.startDate ? new Date(job.startDate).toISOString().split('T')[0] : undefined,
                    endDate: job.endDate ? new Date(job.endDate).toISOString().split('T')[0] : undefined,
                    status: job.status || 'Planned',
                });
            }
            else {
                setFormData({
                    name: '',
                    jobNumber: '',
                    description: '',
                    clientName: '',
                    location: '',
                    startDate: undefined,
                    endDate: undefined,
                    status: 'Planned',
                });
            }
        }
    }, [open, job]);
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => (Object.assign(Object.assign({}, prev), { [name]: value })));
    };
    const handleSelectChange = (e) => {
        setFormData((prev) => (Object.assign(Object.assign({}, prev), { status: e.target.value })));
    };
    const handleSubmit = () => {
        const jobData = {
            description: formData.description,
            status: formData.status || 'Planned',
            machineId: machineId,
            jobNumber: formData.jobNumber || undefined,
            name: formData.name || undefined,
            clientName: formData.clientName || undefined,
            location: formData.location || undefined,
            startDate: formData.startDate || undefined,
            endDate: formData.endDate || undefined,
        };
        onSave(jobData);
    };
    return (_jsxs(Dialog, { open: open, onClose: onClose, maxWidth: "md", fullWidth: true, children: [_jsx(DialogTitle, { children: job ? 'Edit Job' : 'Add Job' }), _jsx(DialogContent, { children: _jsxs(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }, children: [_jsx(TextField, { name: "description", label: "Description", value: formData.description, onChange: handleChange, multiline: true, rows: 4, fullWidth: true, required: true }), _jsx(TextField, { name: "jobNumber", label: "Job Number", value: formData.jobNumber, onChange: handleChange, fullWidth: true, sx: { display: 'none' } }), _jsx(TextField, { name: "name", label: "Job Name", value: formData.name, onChange: handleChange, fullWidth: true, sx: { display: 'none' } }), _jsx(TextField, { name: "clientName", label: "Client Name (Optional)", value: formData.clientName, onChange: handleChange, fullWidth: true, sx: { display: 'none' } }), _jsx(TextField, { name: "location", label: "Location", value: formData.location, onChange: handleChange, fullWidth: true, sx: { display: 'none' } }), _jsx(TextField, { name: "startDate", label: "Start Date", type: "date", value: formData.startDate || '', onChange: handleChange, InputLabelProps: { shrink: true }, fullWidth: true, sx: { display: 'none' } }), _jsx(TextField, { name: "endDate", label: "End Date", type: "date", value: formData.endDate || '', onChange: handleChange, InputLabelProps: { shrink: true }, fullWidth: true, sx: { display: 'none' } }), _jsxs(FormControl, { fullWidth: true, sx: { display: 'none' }, children: [_jsx(InputLabel, { children: "Status" }), _jsxs(Select, { name: "status", value: formData.status || 'Planned', onChange: handleSelectChange, label: "Status", children: [_jsx(MenuItem, { value: "Planned", children: "Planned" }), _jsx(MenuItem, { value: "InProgress", children: "In Progress" }), _jsx(MenuItem, { value: "Completed", children: "Completed" }), _jsx(MenuItem, { value: "Cancelled", children: "Cancelled" })] })] })] }) }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, children: "Cancel" }), _jsx(Button, { onClick: handleSubmit, variant: "contained", disabled: !formData.description, children: "Save" })] })] }));
};
export default JobModal;
